import React, { PropsWithChildren } from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import "./PasswordRules.scss";

const PasswordRule: React.FC<PropsWithChildren<PasswordRuleProps>> = ({
  isErroneous,
  children,
}) => {
  return (
    <div
      className={classNames(
        "notice notice--small",
        isErroneous
          ? "notice--error icon--close"
          : "notice--success icon--check",
      )}
    >
      {children}
    </div>
  );
};

export type PasswordRuleProps = {
  isErroneous: boolean;
};

const PasswordRules: React.FC = () => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className="password-rules mt-1">
      <PasswordRule
        isErroneous={
          errors.password?.type === "minLength" ||
          errors.password?.type === "maxLength"
        }
      >
        12 bis 32 Zeichen
      </PasswordRule>
      <PasswordRule isErroneous={errors.password?.type === "pattern"}>
        darf keine Leerzeichen oder unzulässige Sonderzeichen enthalten
      </PasswordRule>
      <PasswordRule isErroneous={errors.password?.type === "complexity"}>
        muss Zeichen aus mindestens 3 der 4 Zeichengruppen (Großbuchstaben,
        Kleinbuchstaben, Sonderzeichen oder Ziffern) beinhalten
      </PasswordRule>
    </div>
  );
};

export default PasswordRules;
